import React from 'react';
import { imageSet } from '../../../helper/Images';
import { language, showBoxShotImage, FRESH_LENS_TAB } from 'Root/constants';
import { Image } from '../../../commonComponents';

const Description = ({
  big_img,
  box_img,
  box_shot,
  selectedLensType,
  small_img,
  promotion,
}) => {
  return (
    <div className="tabs--content tabs--content__center">
      <div className="tabs--content__center-wrapper">
        <figure className={ small_img ? `tabs--content__center-left` : 'tabs--content__center-center' }>
          <Image
            className="img-responsive big-lens-image"
            src={imageSet[big_img]}
            alt=""
          />
          { showBoxShotImage ? selectedLensType === FRESH_LENS_TAB ? (
              <Image
              className="img-responsive box-shot-image"
              src={imageSet[box_shot]}
              />
            ) : (
              <Image className="img-responsive" src={imageSet[box_img]} />
            ) : ""
          }
        </figure>
        {small_img && (
          <figure className="tabs--content__center-right">
            <Image
              className="img-responsive"
              src={imageSet[small_img]}
              alt=""
            />
          </figure>
        )}
      </div>
      {/* Not Sure why do we need to keep this even if we are not supporting it */}
      {language === 'zh' && (
        <div className="disclaimer">
          <p>{data.additional_disclaimer.makeup[lensIndex]}</p>
        </div>
      )}
    </div>
  );
};

export default Description;
